import React, { memo, useEffect, useCallback, useState} from 'react';
import PianoRollDropdown from './PianoRollDropdown.js';
import ScrolledViewPort from './ScrolledViewPort.js';
import ScrolledTick from './ScrolledTick.js';

import {connect} from 'react-redux';

const WIDTH = 36;
const MARGIN = 58;

const PianoRollScroll = ({steps, scroll, track, durations, pianoSteps, color, xScale}) => { 
    let [autoScroll, setAutoScroll] = useState(false);
    let length = steps ? steps.length : 0;
    const onMouseDown = useCallback((e) => {
        let x = e.clientX - MARGIN;
        let goalX = x;
        let startRatio = goalX / (window.innerWidth - MARGIN);
        let totalWidth = length * xScale * WIDTH;
        let scrollX = startRatio * totalWidth;
        scroll.current.scroll(scrollX, 0);
    }, [xScale, length]);
 
    let maxNote = 46.0;
    let minNote = -46.0;

    if (steps === undefined) {
        return [];
    }


    return (
        <div className="piano-roll-top">
          <PianoRollDropdown setAutoScroll={setAutoScroll} autoScroll={autoScroll}/>
          <div
            onMouseDown={onMouseDown}
            className="piano-roll-scroll">
            <ScrolledTick stepsLength={length} xScale={xScale} sequencerEngine={track.sequencerEngine} track={track}/>
            <ScrolledViewPort autoScroll={autoScroll} scroll={scroll} steps={steps} track={track} xScale={xScale}/>
            {Object.keys(pianoSteps).filter(note => pianoSteps[note])
             .map(
                 note =>
                     Object.keys(pianoSteps[note]).map(
                         (stepNumber, i) =>
                             <Step
                               key={i}
                               color={color}
                               minNote={minNote}
                               maxNote={maxNote}
                               duration={durations[note][stepNumber]}
                               note={note}
                               length={steps.length}
                               stepNumber={stepNumber}/>))}
          </div>
        </div>
    );
}

const Step = memo(({stepNumber, step, length, note, duration, minNote, maxNote, color}) => {
    let ratio = (note - minNote) / (maxNote - minNote);
    let style = {
        left: ((stepNumber / length) * 100)  + '%',
        width: ((duration / length) * 100)  + '%',
        bottom: Math.min(93, (ratio * 100)) + '%',
        backgroundColor: color
    };

    return (
        <div style={style} className="piano-step">
        </div>
    );
});

const mapStateToProps = (state, props) => {
    let steps = state.tracks.trackSteps[props.track.id];
    let pianoSteps = state.tracks.trackPianoRollSteps[props.track.id];
    let durations = state.tracks.trackPianoRollDurations[props.track.id];
    return {
        resolution: state.sequencer.displayResolution,
        steps: steps,
        durations: durations,
        pianoSteps
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PianoRollScroll);
